import { AfterContentChecked, Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[bcInputAutoFocus]',
    standalone: false
})
export class InputFocusDirective implements AfterContentChecked {
    constructor(private element: ElementRef<HTMLInputElement>) {}

    ngAfterContentChecked(): void {
        this.element.nativeElement.focus();
    }
}
